import parsePhoneNumber, { CountryCode } from 'libphonenumber-js/max';
import { isNil } from 'lodash';
import { PatternValidationRegex } from '~domain/helper/validation-regex';
import { ErrorMessage, Rule } from '~domain/model/core/validation/rule';
import { BaseValidator } from '~domain/validators/core/base-validator';

export class PhoneNumberValidator extends BaseValidator<string> {
  protected rules: Rule<string>[] = [this.createNullRule(), this.validateContent];

  // input format: `+10003334444`
  private validateContent(phoneNumber: string): ErrorMessage {
    const validCountryCodes: CountryCode[] = ['CA', 'US'];
    const phone = parsePhoneNumber(phoneNumber);

    // failed to parse or invalid format (isPossible only validates the length)
    if (isNil(phone) || !PatternValidationRegex.PHONE_NUMBER_PATTERN.test(phoneNumber)) {
      return 'validation.error.invalidPhoneNumber';
    }

    // invalid phone number (ie: invalid area code) or the country is not in the accepted country codes
    if (!phone?.isValid() || !validCountryCodes.includes(phone.country)) {
      return 'validation.error.invalidPhoneNumberCountry';
    }
  }
}
